// import { PlusOutlined } from '@ant-design/icons';
// import { Grid } from 'antd';
import {  ContentFilters, ContentTopBar } from 'components';
// import { AddAdminUserModal } from 'features/users/components/modals/add-admin-user-modal';
// import { UserFilterFormValues } from 'features/users/components/users-filter-form/types';
// import { UsersFilterForm } from 'features/users/components/users-filter-form/users-filter-form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyType } from 'types';

// import { AgentFilterForm, AgentFilterFormValues } from './agent-filter-form';
import { CouponFilterForm } from './Coupon-filter-form';
import { CouponFilterFormValues } from './Coupon-filter-form/types';

// const { useBreakpoint } = Grid;

type UsersTopBarProps = {
  getInitialFilterValues: CouponFilterFormValues;
  handleFilter: (values: CouponFilterFormValues) => void;
  adminUserEditData:any ;
};

export const CouponTopBar = ({

  getInitialFilterValues,
  handleFilter,
}: UsersTopBarProps) => {
  useState<CompanyType>();
  const { t } = useTranslation();
  // const [ setShowAddUserModal] = useState(false);
  // const screens = useBreakpoint();
  const formId = 'users-filters-form';

  // const handleCloseModal = () => {
  //   setShowAddUserModal(false);
  //   document.body.style.overflow = 'visible';
  // }

  // const handleOpenModal = () => {
  //   setShowAddUserModal(true);
  //   document.body.style.overflow = 'hidden';
  // }

  return (
    <>

      <ContentTopBar
        title={t('CopounUser.heading.CouponTitle')}
      />
      <ContentFilters formId={formId}>
        <CouponFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
